import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavBarMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_279_4694",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_279_4694)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5.58285 19.9C5.17351 19.9 4.82401 19.7552 4.53435 19.4657C4.24485 19.1761 4.1001 18.8266 4.1001 18.4172V5.58273C4.1001 5.17339 4.24485 4.82389 4.53435 4.53423C4.82401 4.24473 5.17351 4.09998 5.58285 4.09998H18.4173C18.8267 4.09998 19.1762 4.24473 19.4658 4.53423C19.7553 4.82389 19.9001 5.17339 19.9001 5.58273V18.4172C19.9001 18.8266 19.7553 19.1761 19.4658 19.4657C19.1762 19.7552 18.8267 19.9 18.4173 19.9H5.58285ZM8.4001 18.6V5.39998H5.70785C5.63085 5.39998 5.56035 5.43206 5.49635 5.49622C5.43218 5.56022 5.4001 5.63073 5.4001 5.70773V18.2922C5.4001 18.3692 5.43218 18.4397 5.49635 18.5037C5.56035 18.5679 5.63085 18.6 5.70785 18.6H8.4001ZM9.7001 18.6H18.2923C18.3693 18.6 18.4398 18.5679 18.5038 18.5037C18.568 18.4397 18.6001 18.3692 18.6001 18.2922V5.70773C18.6001 5.63073 18.568 5.56022 18.5038 5.49622C18.4398 5.43206 18.3693 5.39998 18.2923 5.39998H9.7001V18.6Z",
			fill: "currentColor"
		})
	})] })
});
export default SvgNavBarMenu;
